var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Mesh } from "three";
/**
 * Recursively return all the meshes node in a scene
 */
export function listMeshes(objects) {
    var e_1, _a;
    var reducer = [];
    try {
        for (var objects_1 = __values(objects), objects_1_1 = objects_1.next(); !objects_1_1.done; objects_1_1 = objects_1.next()) {
            var node = objects_1_1.value;
            if (node instanceof Mesh && node.material) {
                reducer.push(node);
            }
            if (node.children && node.children.length > 0) {
                reducer.push.apply(reducer, __spreadArray([], __read(listMeshes(node.children)), false));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (objects_1_1 && !objects_1_1.done && (_a = objects_1.return)) _a.call(objects_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return reducer;
}
export function getObjectByName(scene, name, type) {
    var e = getOptionalObjectByName(scene, name, type);
    if (e == null) {
        console.log(scene);
        throw new Error("Object " + name + " not found");
    }
    return e;
}
export function getOptionalObjectByName(scene, name, type) {
    var e = scene.getObjectByName(name);
    if (e == null) {
        return null;
    }
    if (!(e instanceof type)) {
        throw new Error("Object " + name + " is not instance of " + type);
    }
    return e;
}
